import { Prop, Vue, Component } from "vue-property-decorator";
import openAdStyle from "@/views/components/newDisplayConfig/open-show-style.vue";
import { IPSService } from "@/services/ipsServices";
import baseAPIService from "@/services/base/baseAPIService";

@Component({
	components: {},
	mixins: [openAdStyle],
})
export default class ShopDisplayOpenAd extends Vue {
	@Prop({ default: 0 })
	sgId;

	@Prop({ default: 0 })
	siteId;

	pushFrequency = 3;
	public corpId = baseAPIService.resolveCorpId();

	saveFrequency() {
		console.log(this.pushFrequency);
		IPSService.adminSiteGroupConfigSave({
			postParams: {
				siteId: this.siteId,
				sgId: this.sgId,
				corpId: this.corpId,
				pushFrequency: this.pushFrequency,
			},
		}).then((res) => {
			if (res.result) {
				this.$message.success("修改成功！");
			}
		});
	}

	mounted() {
		IPSService.siteGroupConfig({
			postParams: {
				sgId: +this.sgId,
				siteId: this.siteId,
			},
		}).then((res) => {
			this.pushFrequency = res.pushFrequency;
		});
	}
	render(h) {
		return (
			<div class="full-width r-pb-30">
				<div class="font-size-14">开屏广告示意图</div>
				<div class="phone-wrap r-mt-10">
					<img src="https://ssl-picture.tenyun.runsasoft.com/kpgg.png" class="preview-img" alt="" />
				</div>
				<div class="r-mt-20">
					<div class="r-pa-10 bg-yellow-2 font-size-14 border-white row items-baseline">
						<i class="iconfont  text-blue-15 icon-a-5Blaba" />
						<div class="r-ml-6 flex1">当出现多个有效的开屏广告时，系统将随机弹出一个当前顾客可见的广告，且每次仅会弹出一个弹窗。</div>
					</div>
					<div class="r-mt-20 row items-baseline font-size-14 full-width">
						<div class="font-bold r-mr-30">弹出频率</div>
						<el-radio-group class="push-frequency flex1 column text-grey-17" v-model={this.pushFrequency} onChange={() => this.saveFrequency()}>
							<el-radio class="full-width" label={3}>
								每次进入小程序均推送
							</el-radio>
							<el-radio class="full-width r-mt-20" label={2}>
								每天推送一次
							</el-radio>
							<el-radio class="full-width r-mt-20" label={1}>
								仅推送一次
							</el-radio>
						</el-radio-group>
					</div>
				</div>
			</div>
		);
	}
}
